<div class="relative pt-4">
  @if (section(); as section) {
    <div
      class="group flex flex-row items-center h-[44px] mb-1 rounded px-4 gap-1 hover:bg-secondary-100 focus-within:[outline:1px_solid_var(--color-primary)]"
    >
      <app-button2 appearance="secondary-ghost" size="s" (click)="toggleCollapse()">
        <app-icon name="chevron-down" class="transition-transform" [class.-rotate-90]="collapsed()" />
      </app-button2>

      @if (sectionForm(); as form) {
        <input
          #titleInput
          class="font-medium leading-5 placeholder:text-secondary-600 text-secondary-700 [field-sizing:content] max-w-full w-auto outline-none border-0 bg-transparent px-3"
          (blur)="handleBlur()"
          (keydown.enter)="titleInput.blur()"
          placeholder="Section name"
          [formControl]="form.controls.title"
        />
      }

      <div class="flex-1 h-px self-center bg-secondary-300 group-focus-within:opacity-0"></div>

      <app-button2
        class="rotate-90"
        appearance="secondary-ghost"
        size="s"
        matTooltip="More options"
        stchPopoverTrigger="click"
        [appSectionContextMenu]="section"
        [canMoveUp]="canMoveUp()"
        [canMoveDown]="canMoveDown()"
      >
        <app-icon name="sapphire-ellipsis" />
      </app-button2>
    </div>
  }

  <!-- CSS-only collapse: the grid row animates 1fr <-> 0fr, the inner element clips.
       A drag temporarily expands the section so it's a stable drop target. -->
  <div
    class="grid transition-[grid-template-rows] duration-300 ease-in-out"
    [style.gridTemplateRows]="collapsed() && !dragging() ? '0fr' : '1fr'"
  >
    <div class="flex flex-col min-h-0 overflow-hidden">
      @for (column of columns(); track column.id) {
        <app-project-tasks-list-column
          [project]="project()"
          [section]="section()"
          [column]="column"
          [filters]="filters()"
          (openTask)="openTask.emit($event)"
          (openSubtask)="openSubtask.emit($event)"
          (clickTask)="clickTask.emit($event)"
          (doubleClickTask)="doubleClickTask.emit($event)"
        />
      }
    </div>
  </div>
</div>
